// Intl locale for each app locale. Plain `es` puts the peso sign after the amount, so
// Spanish formats as Chilean Spanish.
const LOCALE_TO_INTL: Record<string, string> = {
  en: 'en-US',
  es: 'es-CL',
};

export function toIntlLocale(locale: string): string {
  return LOCALE_TO_INTL[locale] ?? 'es-CL';
}
